import React, { Component } from 'react';

// Interne Module
import * as storage from '@/_helper/storage';
import tracking from '@/_helper/tracking';
import { emitPbeChangeSuccess, emitPbeCloseWebview } from '@/pages/customerarea/claim/ch24-events.app/useAppBridge';

// Komponenten
import Button from '@/comp/button/button';

// Styles
import './style.scss';

/**
 * @param {string} type
 * @param {string} subPage
 * @param {Object=} contact
 * @param {string} backLink
 * @param {string} backLinkText
 */
class StatusPage extends Component {
    // Für C24 Kundenbereich Text
    backLink = this.props.backLink ?? '/';
    backLinkText = this.props.backLinkText ?? 'Zurück zu meiner Reise';

    bookingNumber = storage.get('bookingNumber') ?? undefined;

    pageInformation = {
        index: {
            warningText: (
                <>
                    Ihre Buchungsanfrage konnte aus technischen Gründen nicht ausgeführt werden.
                    <br />
                    <br />
                    Bei Fragen zu dieser Nachricht melden Sie sich bitte beim AurumTours Serviceteam unter{' '}
                    <a href="mailto:service@aurumtours.de">service@aurumtours.de</a>.
                </>
            ),
        },
        claim: {
            title: 'Reklamation',
            successText: (
                <>
                    <h3>Eingangsbestätigung</h3>
                    <p>
                        In Kürze erhalten Sie eine Eingangsbestätigung per E-Mail
                        {this.props.contact?.email ? ' an ' + this.props.contact.email : ''}. Dort finden Sie nochmal
                        eine Zusammenfassung Ihrer Angaben.
                    </p>

                    <h3>Bearbeitung der Reklamation</h3>
                    <p>
                        Wir werden Ihre Reklamation schnellstmöglich bearbeiten und setzen uns anschließend mit Ihnen in
                        Verbindung. Dies wird erfahrungsgemäß 1&nbsp;bis&nbsp;2&nbsp;Wochen dauern. In seltenen Fällen
                        kann die Bearbeitungszeit bis zu 8 Wochen betragen. Wir bedanken uns für Ihre Geduld.
                    </p>
                </>
            ),
            warningText: (
                <>
                    Sie können eine Reklamation erst nach Reiseende einreichen. <br />
                    Bei Problemen oder Fragen vor Ort melden Sie sich bitte beim AurumTours Serviceteam unter{' '}
                    <a href="mailto:service@aurumtours.de">service@aurumtours.de</a>.
                </>
            ),
        },
        cancellation: {
            title: 'Stornierung',
            successText: (
                <>
                    <h3>Stornierungsbestätigung</h3>
                    <p>Sie erhalten in Kürze eine Stornierungsbestätigung per E-Mail.</p>
                    <h3>Zahlung oder Erstattung</h3>
                    <p>
                        Sollten Sie bereits eine Anzahlung oder Restzahlung an uns geleistet haben, wird Ihnen der
                        Differenzbetrag von AurumTours mit der Zahlungsmethode erstattet, die Sie bei der Buchung
                        angegeben haben. Sollten nur die Stornierungskosten anfallen, sind diese mit der ursprünglich
                        angegebenen Zahlungsmethode zu begleichen bzw. werden von AurumTours abgebucht. Wenn Sie
                        Rechnung als Zahlungsmethode gewählt haben, bitten wir um umgehende Überweisung. Detaillierte
                        Zahlungsinformationen dazu erhalten Sie mit Ihrer Stornierungsbestätigung.
                    </p>
                </>
            ),
            errorText: {
                alreadyCancelled:
                    'Ihre Reise wurde bereits storniert, deswegen können Sie keine weiteren Änderungen an der Buchung vornehmen.',
                contactCustomerService: (
                    <>
                        <p>
                            Es tut uns leid, aber wir können gerade keine Auskunft über die Stornierungskosten Ihrer
                            Reise geben.
                        </p>
                        <p>
                            Bitte erfragen Sie diese telefonisch beim AurumTours Serviceteam unter der Telefonnummer{' '}
                            <a className="noLineBreak" href="tel:+4989998299531">
                                +49 89 9982 99 531
                            </a>{' '}
                            oder schreiben Sie eine E-Mail an{' '}
                            <a href="mailto:service@aurumtours.de">service@aurumtours.de</a>
                        </p>
                    </>
                ),
                travelStartAlreadyDone:
                    'Ihre Reise hat bereits begonnen oder liegt in der Vergangenheit. Daher können Sie keine Stornierung mehr vornehmen.',
            },
        },
        partialCancellationExcursion: {
            title: 'Stornierung',
            subline: (
                <>
                    Das hat geklappt! Wir haben die Stornierung Ihres Ausflugs{' '}
                    {this.bookingNumber !== undefined && (
                        <>
                            zur Buchung <b>{this.bookingNumber}</b>{' '}
                        </>
                    )}
                    erhalten.
                </>
            ),
            successText: (
                <>
                    <h3>Stornierungsbestätigung</h3>
                    <p>Sie erhalten in Kürze eine aktualisierte Rechnung per E-Mail.</p>
                    <h3>Zahlung oder Erstattung</h3>
                    <p>
                        Sollten Sie bereits eine Anzahlung oder Restzahlung an uns geleistet haben, wird Ihnen der
                        Differenzbetrag von AurumTours mit der Zahlungsmethode erstattet, die Sie bei der Buchung
                        angegeben haben. Sollten nur die Stornierungskosten anfallen, sind diese mit der ursprünglich
                        angegebenen Zahlungsmethode zu begleichen bzw. werden von AurumTours abgebucht. Wenn Sie
                        Rechnung als Zahlungsmethode gewählt haben, bitten wir um umgehende Überweisung. Detaillierte
                        Zahlungsinformationen dazu erhalten Sie mit Ihrer Stornierungsbestätigung.
                    </p>
                </>
            ),
        },
        partialCancellationSeatReservation: {
            title: 'Stornierung',
            subline: <>{this.props?.subline}</>,
            successText: (
                <>
                    <h3>Stornierungsbestätigung</h3>
                    <p>Sie erhalten in Kürze eine aktualisierte Rechnung per E-Mail.</p>
                    <h3>Zahlung oder Erstattung</h3>
                    <p>
                        Sollten Sie bereits eine Anzahlung oder Restzahlung an uns geleistet haben, wird Ihnen der
                        Differenzbetrag von AurumTours mit der Zahlungsmethode erstattet, die Sie bei der Buchung
                        angegeben haben. Sollten nur die Stornierungskosten anfallen, sind diese mit der ursprünglich
                        angegebenen Zahlungsmethode zu begleichen bzw. werden von AurumTours abgebucht. Wenn Sie
                        Rechnung als Zahlungsmethode gewählt haben, bitten wir um umgehende Überweisung. Detaillierte
                        Zahlungsinformationen dazu erhalten Sie mit Ihrer Stornierungsbestätigung.
                    </p>
                </>
            ),
        },
        seatReservation: {
            title: 'Sitzplatzreservierung',
            errorText: 'Zu Ihrer Buchung sind aktuell leider keine Angebote verfügbar.',
        },
        apis: {
            title: 'Reisepassdaten',
        },
        credit: {
            titleCustom: 'Das hat geklappt! Die Angabe Ihrer Daten ist bei uns angekommen.',
            successText: (
                <>
                    <h3>Gutschrift</h3>
                    <p>In Kürze erhalten Sie eine Gutschrift über die angegebene Bankverbindung.</p>
                </>
            ),
            backLink: true,
        },
        tourGuide: {
            titleCustom: (
                <>
                    <p>
                        Vielen Dank! Sie wurden erfolgreich für die digitale Reiseleitung von AurumTours angemeldet.
                        <br />
                        <span className="text-bold">Wir melden uns kurz vor Reiseantritt über WhatsApp bei Ihnen.</span>
                    </p>
                    <p style={{ marginTop: '10px' }}>
                        Bei Fragen zur digitalen Reiseleitung wenden Sie sich bitte an{' '}
                        <a href="mailto:digitale.reiseleitung@aurumtours.de">digitale.reiseleitung@aurumtours.de</a>.
                    </p>
                </>
            ),
            errorText: {
                1: 'Da ist was schiefgelaufen! Leider können wir Sie nicht für die digitale Reiseleitung von AurumTours anmelden. Dieser Service wird derzeit nur für Pauschalreisebuchungen mit einer inkludierten Flugleistung angeboten.',
                2: 'Da ist was schiefgelaufen! Leider können wir Sie nicht für die digitale Reiseleitung von AurumTours anmelden. Dieser Service wird derzeit nicht für Ihre Buchung angeboten.',
                3: 'Da ist was schiefgelaufen! Leider können wir Sie nicht für die digitale Reiseleitung von AurumTours anmelden. Dieser Service wird derzeit nicht für Ihre Buchung angeboten.',
                4: 'Da ist was schiefgelaufen! Leider können wir Sie nicht für die digitale Reiseleitung von AurumTours anmelden. Sie haben bereits eine persönliche Reiseleitung vor Ort im Reisezielland.',
                5: 'Da ist was schiefgelaufen! Leider können wir Sie nicht für die digitale Reiseleitung von AurumTours anmelden. Dieser Service wurde bereits für Ihre Buchung aktiviert.',
                6: 'Da ist was schiefgelaufen! Leider können wir Sie nicht für die digitale Reiseleitung von AurumTours anmelden, da Ihre Reise bereits beendet wurde.',
                default:
                    'Da ist was schiefgelaufen! Leider können wir Sie nicht für die digitale Reiseleitung von AurumTours anmelden. Dieser Service wird derzeit nicht für Ihre Buchung angeboten.',
            },
        },
        emergencyContact: {
            titleCustom: (
                <>
                    Vielen Dank! Sie haben einen Notfallkontakt{' '}
                    {this.props.contactName && (
                        <>
                            für <b>{this.props.contactName}</b>{' '}
                        </>
                    )}
                    hinterlegt.
                </>
            ),
        },
        payment: {
            title: 'Zahlung',
        },
        default: {
            title: 'Anfrage',
            successText: <>Wir wissen nicht wie Sie hier gelandet sind, aber es hat geklappt!</>,
            warningText: (
                <>
                    Bei Problemen oder Fragen vor Ort melden Sie sich bitte beim AurumTours Serviceteam unter{' '}
                    <a href="mailto:service@aurumtours.de">service@aurumtours.de</a>.
                </>
            ),
            errorText:
                'Es tut uns leid, aber hier ist wohl etwas schiefgelaufen! Bitte versuchen Sie es später erneut.',
        },
    };

    constructor(props) {
        super(props);

        this.type = this.props.type !== undefined ? this.props.type : 'error';
        this.showButton = this.props.showButton !== undefined ? this.props.showButton : true;

        if (window.$affiliate === 'ch24' && storage.get('bookingData')) {
            const bookingData = storage.get('bookingData');

            if (
                bookingData.data.pbeHash !== null &&
                bookingData.data.pbeHash !== undefined &&
                bookingData.data.pbeHash !== ''
            ) {
                this.backLink = new URL(bookingData.data.pbeHash).origin + new URL(bookingData.data.pbeHash).pathname;
            } else {
                this.backLink = 'https://kundenbereich.check24.de/';
            }
        }
    }

    componentDidMount() {
        this.type = this.props.type !== undefined ? this.props.type : 'error';
    }

    successForm() {
        tracking('success', this.props.subPage);
        if (!window.$affiliate) {
            window.$gtmTracking.gtag('event', 'page_success', { page: this.props.subPage });
        }

        // trigger fetch new data
        if (window.$revalidateEnabled) {
            storage.set('refreshData', new Date().getTime());
        }

        if (window.$affiliate === 'ch24' && this.props.subPage === 'claim') {
            // c24App :: connection
            emitPbeChangeSuccess();
        }

        return (
            <>
                <div className="success-banner">
                    <div className="icon"></div>
                    {(() => {
                        if (
                            this.pageInformation[this.props.subPage] !== undefined &&
                            this.pageInformation[this.props.subPage].title
                        ) {
                            if (this.pageInformation[this.props.subPage].subline !== undefined) {
                                return <>{this.pageInformation[this.props.subPage].subline}</>;
                            } else {
                                return (
                                    <>
                                        Das hat geklappt! Ihre {this.pageInformation[this.props.subPage].title}{' '}
                                        {this.bookingNumber !== undefined ? (
                                            <>
                                                zur Buchung <b>{this.bookingNumber}</b>{' '}
                                            </>
                                        ) : (
                                            <>zu Ihrer Buchung </>
                                        )}
                                        {this.props.subPage === 'apis' ? 'sind' : 'ist'} bei uns eingegangen.
                                    </>
                                );
                            }
                        } else if (
                            this.pageInformation[this.props.subPage] !== undefined &&
                            this.pageInformation[this.props.subPage].titleCustom
                        ) {
                            return <>{this.pageInformation[this.props.subPage].titleCustom}</>;
                        } else {
                            return <>{this.pageInformation['default'].successText}</>;
                        }
                    })()}
                </div>
                <section className="content-wrapper">
                    {this.pageInformation[this.props.subPage] !== undefined &&
                        this.pageInformation[this.props.subPage].successText && (
                            <div className="article">
                                <h2>Wie geht's weiter?</h2>
                                {this.pageInformation[this.props.subPage].successText}
                            </div>
                        )}
                    {this.pageInformation[this.props.subPage]?.backLink !== false && (
                        <div className="user-action">
                            <a
                                rel="noopener noreferrer"
                                className="button-element"
                                href={this.backLink}
                                dangerouslySetInnerHTML={{
                                    __html: this.backLinkText,
                                }}></a>
                        </div>
                    )}
                </section>
            </>
        );
    }

    errorForm() {
        if (this.props.subPage !== 'error') {
            let subPage = this.props.subPage;

            if (subPage.includes('booking-')) {
                subPage = this.props.subPage.replace('booking-', '');
            }

            if (this.props.trackData === undefined || this.props.trackData !== false) {
                tracking('error', subPage);
            }
        }

        return (
            <>
                <div className="error-banner">
                    <div className="icon"></div>
                    {this.props.subPage === 'booking' ||
                    this.props.subPage === 'booking-seatReservation' ||
                    this.props.subPage === 'booking-insurance' ||
                    this.props.subPage === 'booking-railAndFly' ||
                    this.props.subPage === 'booking-transfer' ||
                    this.props.subPage === 'booking-excursion' ? (
                        <>
                            Bei Ihrer Buchung{' '}
                            {this.bookingNumber !== undefined && (
                                <>
                                    <b>{this.bookingNumber}</b>{' '}
                                </>
                            )}
                            ist leider etwas schiefgelaufen und muss durch unser Serviceteam geprüft werden.
                        </>
                    ) : this.pageInformation[this.props.subPage] ? (
                        // has subPage defined specific error text | default error text
                        this.pageInformation[this.props.subPage]?.errorText ? (
                            // error messages : subPage | subPage -> set situational  | default
                            typeof this.pageInformation[this.props.subPage].errorText === 'string' ? (
                                this.pageInformation[this.props.subPage].errorText
                            ) : this.pageInformation[this.props.subPage].errorText[this.props.case] ? (
                                this.pageInformation[this.props.subPage].errorText[this.props.case]
                            ) : (
                                this.pageInformation['default'].errorText
                            )
                        ) : (
                            this.pageInformation['default'].errorText
                        )
                    ) : (
                        this.pageInformation['default'].errorText
                    )}
                </div>

                {this.props.subPage === 'booking' ||
                this.props.subPage === 'booking-seatReservation' ||
                this.props.subPage === 'booking-insurance' ||
                this.props.subPage === 'booking-railAndFly' ||
                this.props.subPage === 'booking-transfer' ||
                this.props.subPage === 'booking-excursion' ? (
                    <section className="content-wrapper">
                        <div className="article">
                            <h2>Wie geht's weiter?</h2>
                            <h3>Wie geht's weiter?</h3>
                            <p>
                                Das AurumTours Serviceteam wird so schnell wie möglich Kontakt mit Ihnen aufnehmen (per
                                E-Mail oder Telefon) und Sie über den Status der Buchung informieren.
                                <br />
                                <br />
                                Vielen Dank für Ihr Verständnis.
                            </p>
                        </div>

                        <div className="user-action">
                            <a
                                rel="noopener noreferrer"
                                className="button-element"
                                href={this.backLink}
                                dangerouslySetInnerHTML={{
                                    __html: this.backLinkText,
                                }}></a>
                        </div>
                    </section>
                ) : (
                    <div className="user-action">
                        {this.showButton && (
                            <>
                                {this.props.subPage === 'claim' &&
                                storage.get('mode') !== null &&
                                storage.get('mode') === 'app' ? (
                                    <Button
                                        classList={'button'}
                                        label={this.backLinkText}
                                        handleClick={() => {
                                            emitPbeChangeSuccess();
                                            emitPbeCloseWebview();
                                        }}
                                    />
                                ) : (
                                    <a
                                        rel="noopener noreferrer"
                                        className="button-element"
                                        href={this.backLink}
                                        dangerouslySetInnerHTML={{
                                            __html: this.backLinkText,
                                        }}></a>
                                )}
                            </>
                        )}
                    </div>
                )}
            </>
        );
    }

    warningForm() {
        return (
            <>
                <div className="warning-banner">
                    <div className="icon"></div>
                    {this.pageInformation[this.props.subPage] && this.pageInformation[this.props.subPage].warningText
                        ? this.pageInformation[this.props.subPage].warningText
                        : this.pageInformation['default'].warningText}
                </div>
                {this.props.bookingState !== 'NO' && (
                    <div className="user-action">
                        <a
                            rel="noopener noreferrer"
                            className="button-element"
                            href={this.backLink}
                            dangerouslySetInnerHTML={{
                                __html: this.backLinkText,
                            }}></a>
                    </div>
                )}
            </>
        );
    }

    render() {
        return (
            <div className="component-status redesign">
                {this.type === 'success'
                    ? this.successForm()
                    : this.type === 'warning'
                      ? this.warningForm()
                      : this.errorForm()}
            </div>
        );
    }
}

export default StatusPage;
